import React, { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import AutoSizer from "react-virtualized-auto-sizer";
import { HighlightSpan } from "./PriceBoardTotalMode";
import { formatNumberToB, formatQtty, formatQttyFull_emptyIsZezo } from "../helpers/utils";

export default memo(function PriceBoardExpandMode(props) {
  const { t } = useTranslation();
  const expandIndexesHose = useSelector(state => state.gIndex.expandIndexesHose);
  const expandIndexesHNX = useSelector(state => state.gIndex.expandIndexesHNX);
  const idxHose = useSelector(state => state.gIndex.indexInfos?.filter(x => expandIndexesHose.includes(x.indexCode)));
  const idxHNX = useSelector(state => state.gIndex.indexInfos?.filter(x => expandIndexesHNX.includes(x.indexCode)));

  //
  return (
    <div style={{ flex: "1" }}>
      <AutoSizer>
        {({ height, width }) => {
          return (
            <div className="expand" style={{ width: width, height: height }}>
              <div className="expand-content">
                <div className="expand-left">
                  <div className="expand-title">{t("lblBoChiSoHSX")}</div>
                  <div className="expand-table">
                    <ExpandTable listIndex={idxHose} />
                  </div>
                </div>
                <div className="expand-right">
                  <div className="expand-title">{t("lblBoChiSoHNX")}</div>
                  <div className="expand-table">
                    <ExpandTable listIndex={idxHNX} />
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </AutoSizer>
    </div>
  );
});


const ExpandTable = (props) => {
  const { listIndex } = props;
  return (
    <table>
      <thead>
        <tr>
          <th className="w-80 mw-80"></th>
          <th>Chỉ số</th>
          <th>(+/-)</th>
          <th>(%)</th>
          <th>KL</th>
          <th>Giá</th>
          <th>
            <img src="/static/img/icon/icon-gr-up.svg" alt="img" />
          </th>
          <th><img src="/static/img/icon/icon-bl-yl.svg" alt="img" /></th>
          <th><img src="/static/img/icon/icon-down.svg" alt="img" /></th>
        </tr>
      </thead>
      <tbody>
        {listIndex && listIndex.map((item, index) => {
          return (
            <ExpandTableRow key={index} indexInfo={item} />
          )
        })}
      </tbody>
    </table>
  )
}

const ExpandTableRow = (props) => {
  const { indexInfo } = props;
  const prevIndexInfo = useRef(""); // .current
  const _fireEvent = prevIndexInfo.current === indexInfo.indexCode;

  useEffect(() => {
    prevIndexInfo.current = indexInfo.indexCode;
  }, [indexInfo.indexCode]);
  //
  return (
    <tr>
      <td className="w-120">{indexInfo?.indexCode}</td>
      <td className={clsx(indexInfo?.currentIndex_color, "text-right")}>
        <HighlightSpan id={indexInfo.indexCode + "_currentIndex"} value={formatQttyFull_emptyIsZezo(indexInfo?.currentIndex)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx(indexInfo?.changeIndex_color, "text-right")}>
        <HighlightSpan id={indexInfo.indexCode + "_changeIndexx"} value={formatQttyFull_emptyIsZezo(indexInfo?.changeIndex)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx(indexInfo?.pctChangeIndex_color, "text-right")}>
        <HighlightSpan id={indexInfo.indexCode + "_pctChangeIndex"} value={formatQttyFull_emptyIsZezo(indexInfo?.pctChangeIndex)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx(indexInfo?.currentIndex_color, "text-right mw-60")}>
        <HighlightSpan id={indexInfo.indexCode + "_totalTradedQtty"} value={formatQttyFull_emptyIsZezo(indexInfo?.totalTradedQtty)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx(indexInfo?.currentIndex_color, "text-right mw-40")}>
        <HighlightSpan id={indexInfo.indexCode + "_totalTradedValue"} value={formatNumberToB(indexInfo?.totalTradedValue)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx("clr-up", "text-right")}>
        <HighlightSpan id={indexInfo.indexCode + "_currentIndex"} value={formatQttyFull_emptyIsZezo(indexInfo?.up)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx("clr-ref", "text-right")}>
        <HighlightSpan id={indexInfo.indexCode + "_noChange"} value={formatQttyFull_emptyIsZezo(indexInfo?.noChange)} fireEvent={_fireEvent} />
      </td>
      <td className={clsx("clr-down", "text-right")}>
        <HighlightSpan id={indexInfo.indexCode + "_currentIndex"} value={formatQttyFull_emptyIsZezo(indexInfo?.down)} fireEvent={_fireEvent} />
      </td>
    </tr >
  )
}